import type { JSX } from 'react';
import React, { useState } from 'react';
import { GCStatusType } from '@apply/constants';
import { GenericPopup } from '@apply/components';
import { StatusIndicator } from '../components/UserManagementSectionTabPanel/components/ByUserPanel/components/components/StatusIndicator';

export enum Section {
    ByProperty = 'By Property',
    ByUser = 'By User',
}

const ByUserWithLegend: React.FC = () => {
    const [showLegend, setShowLegend] = useState(false);

    return (
        <>
            <span>
                Manage draw request users.{' '}
                <button
                    type="button"
                    onClick={() => setShowLegend(true)}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: '#2C5591',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        padding: 0,
                        font: 'inherit',
                    }}
                >
                    View status legend
                </button>
            </span>
            <GenericPopup
                id="statusLegendModal"
                isOpen={showLegend}
                handleClose={() => setShowLegend(false)}
                title="Status Legend"
                width="500px"
                showCloseButton={true}
                showTitle={true}
                hideOnOutsideClick={true}
            >
                <div style={{ padding: '20px', lineHeight: '1.8' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                        <div style={{ marginRight: '12px' }}>
                            <StatusIndicator status={GCStatusType.Invited} />
                        </div>
                        <span>User has not yet accepted their invite.</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                        <div style={{ marginRight: '12px' }}>
                            <StatusIndicator status={GCStatusType.NeedsProject} />
                        </div>
                        <span>User has accepted their invite, but has not been assigned to any properties.</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                        <div style={{ marginRight: '12px' }}>
                            <StatusIndicator status={GCStatusType.Pending} />
                        </div>
                        <span>User has been assigned to properties, but has not yet accepted their role as GC.</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                        <div style={{ marginRight: '12px' }}>
                            <StatusIndicator status={GCStatusType.Activated} />
                        </div>
                        <span>User is ready to request draws for assigned properties.</span>
                    </div>
                </div>
            </GenericPopup>
        </>
    );
};

export const ManageUserSectionDirections: Record<Section, JSX.Element> = {
    [Section.ByProperty]:
        <>
            You may allow others to submit draw requests.  To do so: (1) use the Invite User button and then (2) use
            the Add User for each relevant property.
        </>,
    [Section.ByUser]: <ByUserWithLegend />,
};
